<template>
    <div class="TeamList" style="display:flex;flex-direction:column; max-height:85vh;">
        <h2>Wrap Teams <font-awesome-icon :icon="['fa', 'sync-alt']" v-on:click="RefreshDataTable()" class="olive-green-text pointer table-refresh client-list" /></h2>
        <form class="table-filters client-list">
            <div class="row">
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Program:</label>
                        <select class="form-control" v-model="Filters.SubprogramID" @change="GetSupervisors">
                            <option value="">All</option>
                            <option v-for="option in SubProgramOptions" v-bind:value="option.value">{{ option.text }}</option>
                        </select>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <label>Supervisor:</label>
                        <select class="form-control" v-model="Filters.SupervisorID">
                            <option value="">All</option>
                            <option v-for="option in SupervisorOptions" :value="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </form>
        <div style="overflow:auto">
            <vuetable :fields="TeamsTableOptions.Fields"
                      :data="LoadedTeams"
                      pagination-path=""
                      :api-mode="false"
                      class="vue-datatable"
                      ref="datatable"
                      id="teamsdatatableid">

                <template slot="TeamRecordName" scope="props">
                    <div class="TeamRecordName">
                        <span class="underline pointer" @click="OpenTeamRecord(props.rowData.Id, props.rowData)" v-html="props.rowData.Name"></span>
                    </div>
                </template>
            </vuetable>
        </div>
    </div>
</template>

<script>
    import { EventBus } from '../../../services/event-bus.js';
    import Vuetable from 'vuetable-2/src/components/Vuetable'
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSyncAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faSyncAlt);
    export default {
        name : "TeamList",
        props: [],
        data: function () {
            return {
                Filters: {
                    SubprogramID: "",
                    SupervisorID: ""
                },

                TeamsTableOptions: {
                    Fields: [
                        {
                            name: '__slot:TeamRecordName',
                            title: 'Team Name',
                        },
                        {
                            name: 'ClientSubProgramMemberships',
                            title: 'Clients',
                            callback: 'ClientCount',
                            dataClass: 'd-none d-xl-table-cell',
                            titleClass: 'd-none d-xl-table-cell',
                        },
                        { 
                            name: 'Address.City',
                            title: 'Location',
                            dataClass: 'd-none d-xl-table-cell',
                            titleClass: 'd-none d-xl-table-cell',
                        },
                        {
                            name: 'EmployeeMemberships',
                            title: 'Supervisor',
                            callback: 'CurrentRole|Supervisor',
                            dataClass: 'd-none d-lg-table-cell',
                            titleClass: 'd-none d-lg-table-cell',
                        },
                        {
                            name: 'EmployeeMemberships',
                            title: 'Facilitator',
                            callback: 'CurrentRole|Facilitator',
                            dataClass: 'd-none d-lg-table-cell',
                            titleClass: 'd-none d-lg-table-cell',
                        },
                        {
                            name: 'EmployeeMemberships',
                            title: 'BHS',
                            callback: 'CurrentRole|Behavioral Health Specialist',
                            dataClass: 'd-none d-lg-table-cell',
                            titleClass: 'd-none d-lg-table-cell',
                        },
                        {
                            name: 'EmployeeMemberships',
                            title: 'Parent Partner',
                            callback: 'CurrentRole|Parent Partner',
                            dataClass: 'd-none d-lg-table-cell',
                            titleClass: 'd-none d-lg-table-cell',
                        },
                        {
                            name: 'EmployeeMemberships',
                            title: 'Clinician',
                            callback: 'CurrentRole|Clinician',
                            dataClass: 'd-none d-xl-table-cell',
                            titleClass: 'd-none d-xl-table-cell',
                        },
                    ]
                },
                Supervisors : []
            };
        },
        methods: {
            RefreshDataTable() {
                this.GetTeams();
            },

            // Returns the name of the worker that has role TeamMemberRole
            CurrentRole(CurrentTeamMembers, TeamMemberRole){
                let filteredList = CurrentTeamMembers.filter(r => r.EndDate == null && r.EmployeeRole == TeamMemberRole);
                if (filteredList.length > 0) {
                    return filteredList.map(e => e.Employee.Person.FullName).join(', ');
                } else {
                    return "UNASSIGNED"
                }
            },
            ClientCount(currentClients) {
                return currentClients.length;
            },

            // TO DO: Get supervisors

            GetTeams() {
                // Use Master API to call GetTeams endpoint
                this.$MasterAPI.ExecuteRequest("GET",'Wraparound/Teams/GetTeams', 
                    { 
                        //SubprogramID: this.Filters.SubprogramID,
                        //SupervisorID: this.Filters.SupervisorID
                    }, this.GetTeamsSuccess, this.GetTeamsError,true
                )
            },
            GetTeamsSuccess(response) {
                this.$store.commit("Teams.TeamEnrollmentList.Replace", response.data.data);
            },
            GetTeamsError(response) {
                console.log("Some error occurred");
            },
            // Adds the team record in the TeamPane component
            OpenTeamRecord(WrapTeamId, TeamRecordData) {
                // Append team data to team profiles
                this.$store.commit("Teams.TeamProfiles.Append", TeamRecordData);
                // Change pane
                this.$parent.ChangePaneShown(WrapTeamId);
            }
        },

        components: {
            Vuetable,
            EventBus
        },
        
        computed: {
            LoadedTeams: function () {
                // gets the Client Enrollment List from the store
                return this.$store.state.Teams.TeamEnrollmentList;
            },
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            }
        },

        mounted() {
            var vm = this;
            //Get Team Records*/
            this.GetTeams();
            let getTeamsFunc = function () {
                vm.GetTeams();
            };
            this.$GlobalUpdate.AddGlobalUpdateFunction(getTeamsFunc);
        }
    }
</script>

<style scoped>
    /*sticky table header*/
    /deep/ .vue-datatable thead {
        position: sticky;
        top: -1px;
        background: white;
    }
    /*no wrap text on columns*/
    /deep/ .vue-datatable tbody td {
        white-space: nowrap !important;
    }
</style>